import React from "react"
import { useSelector } from "react-redux"

import { ANCHOR_TOP } from "const"
import { StoreType } from "client/store"
import {
    Layout,
    Header,
    ContentColumn,
    ContentColumnHeader,
    ContentWrapper,
    Footer,
} from "client/parts/layout"
import {
    LostConnection,
    LangSwitcher,
} from "client/components"

import Menu from "client/parts/menu"
import Profile from "client/parts/profile"
import { Content, ContentExpired } from "client/parts/content"
import Modal from "client/parts/modal"
import Sidebar from "client/parts/sidebar"
import SilCalculations from "client/parts/silCalculations"
import PackageExpiredNotification from "client/parts/packageExpiredNotification"

import { CreateRoutes } from "client/parts/routes"

import Cart from "client/pages/mt/billing/cart"

const App = () => {
    const packageActive = useSelector((state: StoreType) => state.system.packageActive)
    const renderContent = useSelector((state: StoreType) => state.system.renderContent)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lostServerConnection = useSelector((state: StoreType) => state.system.lostServerConnection)
    const { routes } = CreateRoutes()

    const packageExpireDate = packageActive ? new Date(packageActive.dateEnd) : null
    const now = new Date()
    const expired = packageExpireDate ? packageExpireDate <= now : false

    return (
        <Layout>
            { lostServerConnection && <LostConnection /> }

            <Header />
            <Menu routes={routes} />
            <ContentColumn>
                <ContentColumnHeader id={ANCHOR_TOP}>
                    {
                        userData.accountId !== 1 // Super Admin has no "package usage"
                        && <SilCalculations />
                    }
                    {
                        userData.accountId !== 1
                        && <Cart />
                    }
                    <LangSwitcher />
                    <Profile />
                </ContentColumnHeader>
                <ContentWrapper>
                    {
                        renderContent && (
                            expired ? <ContentExpired /> : <Content />
                        )
                    }
                </ContentWrapper>
                <Footer />
            </ContentColumn>
            <Modal />
            <Sidebar />
            <PackageExpiredNotification />
        </Layout>
    )
}
export default App
